import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_doc_approval_request_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  approval_due_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_token: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approval_history_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
}

export class bl_aat_claim_doc_approval_request_queue_RowClass implements bl_aat_claim_doc_approval_request_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  approval_sequence_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  approver_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approver_login_subject_guid: fromDatatype.GuidDataFieldInterface;
  approval_due_date: fromDatatype.TimestampTzDatatypeInterface;
  approval_token: fromDatatype.VarcharDatatypeInterface;
  approval_workflow_type: fromDatatype.VarcharDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  approval_history_posting_status: fromDatatype.VarcharDatatypeInterface;
  approval_sequence_queue_posting_status: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
}
